export default __webpack_public_path__ + "static/media/15.f130f164.jpg";